/* =============================================================
   ATHLIX — Bewegung
   Ein einziger IntersectionObserver fuer alle [data-ax-reveal].
   Staffelt Geschwister automatisch. Respektiert prefers-reduced-motion.
   Kein Framework, keine Abhaengigkeit.
   ============================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  // Notbremse: Egal was passiert — nach 3 Sekunden ist alles sichtbar.
  // Verhindert, dass ein haengender Observer oder eine steckengebliebene
  // Transition Inhalt dauerhaft verschluckt.
  // Die Notbremse rettet nur, was sichtbar sein muesste, statt pauschal
  // alles einzublenden. Vorher nahm sie nach drei Sekunden ax-motion weg
  // -- damit war jede Bewegung fuer den Rest der Seite erledigt, weil
  // alles, was spaeter ins Bild kommt, schon sichtbar war.
  var beobachterHatGefeuert = false;

  function failsafe() {
    setTimeout(function () {
      if (!beobachterHatGefeuert) {
        root.classList.remove('ax-motion');
        showAll();
        return;
      }

      document.querySelectorAll('[data-ax-reveal]:not(.ax-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('ax-in');
      });
    }, 3000);
  }

  function showAll() {
    document.querySelectorAll('[data-ax-reveal]').forEach(function (el) {
      el.classList.add('ax-in');
    });
  }

  // Ohne Bewegungswunsch oder ohne Observer: alles sofort sichtbar zeigen.
  if (reduce || !('IntersectionObserver' in window)) {
    // Keine Bewegung: ax-motion wird gar nicht erst gesetzt, nichts ist versteckt.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showAll);
    } else {
      showAll();
    }
    return;
  }

  // Ab hier ist Bewegung gewollt und moeglich: erst jetzt darf versteckt werden.
  root.classList.add('ax-motion');

  // Die Einblendung des Basisthemes wird sofort stillgelegt, nicht erst
  // wenn sie haengt. Vorher liefen zwei Systeme nebeneinander: der
  // Vendor versteckte, unsere Einblendung blendete ein, und die
  // Notbremse riss nach drei Sekunden nach. Das Ergebnis war ein
  // Flackern -- Elemente sprangen, verschwanden kurz und kamen hart
  // zurueck. Ein System reicht, und es ist unseres.
  root.classList.add('ax-vendor-notaus');

  failsafe();

  // Staffelung nach dem Muster der Ghostline-Seite: 55ms Schritt, der
  // nach vier Elementen wieder von vorn beginnt. Vorher war es
  // 90ms mal Geschwisterindex mit Deckel bei fuenf -- bei einer Reihe
  // aus acht Karten wartete die letzte fast eine halbe Sekunde, und
  // die Reihe lief sichtbar auseinander.
  var STEP = 55;
  var ZYKLUS = 4;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;

      // Der Versatz wird beim Registrieren gesetzt (siehe observe()),
      // nicht erst hier -- so ist er schon da, wenn das Element ins
      // Bild kommt, und es gibt keinen Sprung im ersten Bild.

      beobachterHatGefeuert = true;
      el.classList.add('ax-in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.09 });

  // Was sich bewegen soll, ohne es in jedes Template zu schreiben.
  // Bewusst NICHT der Kaufbereich: wer kaufen will, soll nicht auf eine
  // Einblendung warten. Header und Footer bleiben ebenfalls ruhig.
  // Bis hierher standen nur Ueberschriften und die Athlix-Bausteine der
  // Produktseite in dieser Liste. Alle anderen Seiten hatten deshalb
  // fast keine Einblendung -- Karten, Kacheln und Textbloecke waren
  // einfach da. Jetzt dieselbe Bewegung ueberall.
  var AUTO = [
    // Ueberschriften und Vorspann jeder Section
    '.shopify-section h2.hdt-heading',
    '.shopify-section h1.hdt-heading',
    '.hdt-section-title .hdt-text-block',
    // Athlix-Bausteine der Produktseite
    '.ax-cards__head',
    '.ax-card',
    '.ax-size__say',
    '.ax-size__models',
    // Karten und Kacheln quer durch den Shop
    '.hdt-card-product',
    '.hdt-post-card',
    '.hdt-media-card-item',
    '.hdt-feature-box',
    '.hdt-testimonial-item',
    '.hdt-iwto',
    '.hdt-icon-item',
    '.hdt-collection-item',
    // Medien- und Textbloecke
    '.hdt-section__faqs .hdt-accordion',
    '.hdt-section__hero-media .hdt-media-overlap-content',
    '.hdt-scroll-media-with-text__text',
    '.hdt-media-text-item',
    '.hdt-article-block--content > *'
  ].join(',');

  function finde(wurzel, selector) {
    var basis = wurzel || document;
    var treffer = [];
    if (basis.nodeType === 1 && basis.matches(selector)) treffer.push(basis);
    return treffer.concat([].slice.call(basis.querySelectorAll(selector)));
  }

  function markieren(wurzel) {
    finde(wurzel, AUTO).forEach(function (el) {
      if (el.closest('.hdt-product__info-container')) return;
      if (el.closest('.hdt-header') || el.closest('.hdt-footer')) return;
      if (!el.hasAttribute('data-ax-reveal')) el.setAttribute('data-ax-reveal', '');
    });
  }

  function observe(root) {
    markieren(root);
    finde(root, '[data-ax-reveal]:not(.ax-in)').forEach(function (el, i) {
      if (!el.style.getPropertyValue('--ax-delay')) {
        el.style.setProperty('--ax-delay', (i % ZYKLUS) * STEP + 'ms');
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); });
  } else {
    observe();
  }

  // Medienflaechen: einmaliger, ruhiger Zoom beim Erscheinen.
  // Eigener Beobachter, weil hier nichts versteckt wird -- es bewegt sich
  // nur eine Skalierung. Faellt das JS aus, bleibt die Flaeche normal.
  // Groessenangabe der Models als Auflage ins erste Produktbild.
  // Marvin wollte sie nicht als Zeilen neben dem Kaufbereich, sondern
  // unten rechts im Bild. Der Medienbereich des Themes nimmt keine
  // eigenen Bausteine an (blocks/_product-media.liquid erlaubt keine),
  // deshalb wird die vorhandene Gruppe verschoben statt neu gebaut.
  // Nur ab 1150px: darunter steht sie im Fluss besser lesbar.
  // Zweifarbige Abschnittsueberschriften: das letzte Wort gedaempft.
  // Die Athlix-Bausteine bringen dafuer ein <em> mit, die Sections des
  // Themes nicht -- dort wird es hier nachgetragen, damit ueberall
  // dasselbe Muster steht. Der Text selbst bleibt unveraendert.
  function zweifarbig(wurzel) {
    // Auch h1: Warenkorb, Blogliste, Artikel, Kollektionsbanner und die
    // Kontaktseite geben ihre Abschnittsueberschrift als h1 aus. Ohne
    // sie blieb das gedaempfte Ende auf fast allen Seiten ausser der
    // Produktseite aus -- gemessen sieben von acht Ueberschriften der
    // Startseite ohne <em>. Der Produkttitel ist ausgenommen: er ist
    // ein Name, keine Abschnittsueberschrift.
    var selector =
      '.shopify-section h2.hdt-heading, .shopify-section h1.hdt-heading,' +
      '.shopify-section .hdt-section-title h1, .collection-hero__title,' +
      // Die Rechtsseiten (AGB, Datenschutz, Versand) kommen von Shopify
      // und tragen keine Theme-Klassen. Ohne sie blieb ihr Titel als
      // einziger im Shop einfarbig.
      '.shopify-policy__title h1, .ax-post__titel,' +
      '.ax-vs__h, .ax-jobs__h';
    finde(wurzel, selector).forEach(function (h) {
      if (h.dataset.axZwei || h.querySelector('em')) return;
      if (h.closest('.hdt-product__info-container')) return;
      if (h.closest('.hdt-header') || h.closest('.hdt-footer')) return;
      // Produktname und Kartentitel sind Namen, keine Ueberschriften.
      if (h.closest('.hdt-main-product') || h.closest('.hdt-media-card-item')) return;
      if (h.closest('.hdt-product-card') || h.closest('.hdt-post-card')) return;
      // Die Zweifarbigkeit gehoert zu ABSCHNITTSueberschriften. Die
      // Symbolkaesten der Trust-Zeile benutzen dieselbe Klasse, sind aber
      // 12.5px kleine Beschriftungen -- "Wir sind fuer dich da" mit
      // gedaempftem "da" sah nach Fehler aus, nicht nach Gestaltung.
      if (h.closest('.hdt-icon-box-content') || h.closest('[class*="icon-box"]')) return;

      // Das Ziel ist die Ueberschrift selbst -- ausser ihr ganzer Text
      // steckt in genau einem Kind (z.B. <strong>). Dann wird dort
      // gearbeitet, sonst bliebe die Ueberschrift einfarbig, obwohl sie
      // wie jede andere aussieht. Nur dieser eine Fall: bei mehreren
      // Kindern wuerde das Ersetzen des Textes Markup zerstoeren.
      var ziel = h;
      while (ziel.children.length === 1 &&
             ziel.children[0].textContent.trim() === ziel.textContent.trim() &&
             /^(STRONG|B|SPAN|EM|I)$/.test(ziel.children[0].tagName)) {
        ziel = ziel.children[0];
      }
      if (ziel.children.length) return;

      var txt = (ziel.textContent || '').trim();
      var worte = txt.split(/\s+/);
      if (worte.length < 2) return;
      var letztes = worte.pop();
      ziel.textContent = worte.join(' ') + ' ';
      var em = document.createElement('em');
      em.textContent = letztes;
      ziel.appendChild(em);
      h.dataset.axZwei = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { zweifarbig(); });
  } else {
    zweifarbig();
  }
  document.addEventListener('shopify:section:load', function (e) { zweifarbig(e.target); });

  // Shopify Theme Editor: neu geladene Sections mitnehmen
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  // Nachgeladene Abschnitte mitnehmen.
  // Die Produktempfehlungen ("Komplettiere dein Set.") stehen beim ersten
  // Aufruf noch gar nicht im Dokument: sections/product-recommended.liquid
  // rendert die Ueberschrift nur bei recommendations.performed?, sonst
  // steht dort nur ein leeres <product-recommendations>. Das Markup kommt
  // erst beim Heranscrollen per fetch und replaceChildren() -- lange nach
  // DOMContentLoaded. Ein shopify:section:load feuert dabei nicht, das
  // Ereignis gibt es nur im Theme-Editor. Deshalb blieben dort sowohl die
  // zweifarbige Ueberschrift als auch die Einblendung aus.
  var neueWurzeln = [];
  var nachlauf = 0;
  new MutationObserver(function (aenderungen) {
    for (var i = 0; i < aenderungen.length; i++) {
      var hinzu = aenderungen[i].addedNodes;
      for (var j = 0; j < hinzu.length; j++) {
        if (hinzu[j].nodeType === 1) neueWurzeln.push(hinzu[j]);
      }
    }
    if (!neueWurzeln.length || nachlauf) return;
    nachlauf = requestAnimationFrame(function () {
      nachlauf = 0;
      var wurzeln = neueWurzeln.splice(0);
      for (var k = 0; k < wurzeln.length; k++) {
        zweifarbig(wurzeln[k]);
        observe(wurzeln[k]);
      }
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/* --- Grosse Bilder beim Vergroessern des Fensters nachschaerfen ------
   Marvin: Seite im kleinen Fenster oeffnen, warten bis alles geladen
   ist, dann auf Vollbild -- das Heldenbild bleibt weich, es "passt
   sich nicht an der Groesse an".

   Am Heldenbild nachgemessen: das Markup ist in Ordnung. Die Flaeche
   waechst korrekt mit (1280x680 auf 1920x1040), und Chrome laedt beim
   Vergroessern von sich aus eine hoehere Aufloesung nach (width=1400
   auf width=2000). Nur macht das nicht jeder Browser: Safari behaelt
   die einmal gewaehlte Kandidatin aus dem srcset und skaliert sie
   hoch. Auf einem 27-Zoll-Schirm sieht man das sofort.

   Der Anstoss dazu ist harmlos: aendert sich das sizes-Attribut,
   waehlt jeder Browser aus dem vorhandenen srcset neu aus. Wir
   schreiben also nach dem Vergroessern die tatsaechliche Breite in
   Pixeln hinein. Kein Bild wird ersetzt, keine Quelle entfernt --
   die Auswahl laeuft nur noch einmal.
   ------------------------------------------------------------------ */
(function () {
  var lauf;

  function breiteVon(el) {
    var r = el.getBoundingClientRect();
    return Math.round(r.width);
  }

  function nachschaerfen() {
    var bilder = document.querySelectorAll(
      '.hdt-slideshow img[srcset],' +
      '.hdt-section__hero-media img[srcset],' +
      '.ax-jobs__kopfbild img[srcset]'
    );
    for (var i = 0; i < bilder.length; i++) {
      var img = bilder[i];
      var breit = breiteVon(img);

      // Nur grossflaechige Bilder. Produktkacheln und Symbole bleiben
      // aussen vor, dort faellt eine Stufe weniger nicht auf und jeder
      // zusaetzliche Ladevorgang kostet.
      if (breit < 480) continue;

      // Schon scharf genug? Dann nichts tun. Der Faktor 1.05 verhindert,
      // dass wir wegen Rundung bei jedem Ziehen am Fenster neu laden.
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      if (img.naturalWidth && img.naturalWidth >= breit * dpr * 1.05) continue;

      var neu = breit + 'px';
      if (img.getAttribute('sizes') === neu) continue;
      img.setAttribute('sizes', neu);

      // Bei <picture> entscheidet die passende <source>, nicht das <img>.
      var eltern = img.parentElement;
      if (eltern && eltern.tagName === 'PICTURE') {
        var quellen = eltern.querySelectorAll('source[srcset]');
        for (var q = 0; q < quellen.length; q++) {
          var med = quellen[q].getAttribute('media');
          if (med && window.matchMedia && !window.matchMedia(med).matches) continue;
          quellen[q].setAttribute('sizes', neu);
        }
      }
    }
  }

  addEventListener('resize', function () {
    clearTimeout(lauf);
    lauf = setTimeout(nachschaerfen, 220);
  }, { passive: true });

  // Vollbild ueber die Taste loest resize aus, der Wechsel per
  // Fullscreen-API nicht immer -- deshalb zusaetzlich hier.
  document.addEventListener('fullscreenchange', function () {
    clearTimeout(lauf);
    lauf = setTimeout(nachschaerfen, 300);
  });
})();


/* Live-Chat erst nach dem ersten Scrollen zeigen (nur Startseite).
   Marvin wollte die Blase nicht sofort auf dem ersten Bildschirm.
   Schwelle bewusst niedrig: eine Handbewegung reicht. */
(function(){
  if(!document.body || !document.body.classList.contains('hdt-page-type-index')) return;
  var frei = false;
  function freigeben(){
    if(frei) return;
    if(window.scrollY < 80) return;
    frei = true;
    document.body.classList.add('ax-gescrollt');
    window.removeEventListener('scroll', freigeben);
  }
  window.addEventListener('scroll', freigeben, {passive:true});
  freigeben();
})();

/* =============================================================
   Zweitbilder der Produktkarten vorladen.
   Marvin: "hover effekt nice aber benoetigt lang zum ersten mal
   laden." Das zweite Bild steht auf loading="lazy" und wurde erst
   beim ersten Ueberfahren geholt -- der Wisch zog ueber eine leere
   Flaeche.

   Erster Wurf war ein IntersectionObserver nach dem Laden. Der
   lief ins Leere: das Theme rendert das Produktraster nach dem
   Laden neu, und die frisch eingesetzten Bilder waren wieder lazy
   und unbeobachtet. Darum jetzt zweigleisig:
     1. Im Leerlauf alle vorhandenen Zweitbilder auf eager stellen.
     2. Ein MutationObserver faengt neu eingesetzte Karten und
        stellt deren Zweitbilder ebenfalls um (gebuendelt, damit
        das Umstellen selbst keine Schleife ausloest: eager setzen
        aendert den Baum nicht, aber wir schauen nur auf addedNodes).
   ============================================================= */
(function () {
  function laden(img) {
    if (!img || img.dataset.axVorgeladen) return;
    img.dataset.axVorgeladen = '1';
    if (!img.complete) img.loading = 'eager';
  }
  function alle(wurzel) {
    (wurzel || document).querySelectorAll('img.hdt-card-product__media--hover').forEach(laden);
  }
  function ruhig(f) {
    if (window.requestIdleCallback) { requestIdleCallback(f, { timeout: 1500 }); }
    else { setTimeout(f, 400); }
  }
  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    ruhig(function () { geplant = false; alle(); });
  }
  function start() {
    alle();
    new MutationObserver(function (aenderungen) {
      for (var i = 0; i < aenderungen.length; i++) {
        if (aenderungen[i].addedNodes.length) { planen(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'complete') {
    ruhig(start);
  } else {
    window.addEventListener('load', function () { ruhig(start); });
  }
})();

/* =============================================================
   Warenkorb: Umschalter Rabatt/Versand.
   Zwei Pillen nach dem Muster des Sprachfensters; die aktive ist
   weiss gefuellt, darunter steht genau ein Feld. Delegiert auf
   das Dokument, damit es auch nach einem Neuaufbau des Schubfachs
   (Warenkorb-Update ersetzt den DOM) weiter funktioniert.
   ============================================================= */
(function () {
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.ax-cartwerkzeug__tab');
    if (!tab) return;
    var wurzel = tab.closest('.ax-cartwerkzeug');
    if (!wurzel) return;
    var ziel = tab.dataset.axZiel;
    wurzel.querySelectorAll('.ax-cartwerkzeug__tab').forEach(function (t) {
      var aktiv = t === tab;
      t.classList.toggle('is-aktiv', aktiv);
      t.setAttribute('aria-selected', aktiv ? 'true' : 'false');
    });
    wurzel.querySelectorAll('.ax-cartwerkzeug__flaeche').forEach(function (f) {
      f.hidden = f.dataset.axFeld !== ziel;
    });
  });
})();

/* ==========================================================================
   ATHLIX — Ein Auftritt fuer jedes Fenster: Eingang und Ausgang
   ==========================================================================
   Marvin: "schau, dass alle pop ups bessere animationen haben, eingang
   und ausgang, momentan sieht es nicht gut aus."

   Was das Theme mitbringt:
   - Schubladen (Warenkorb, Suche, Menue) fahren sauber von der Seite
     herein -- die bleiben, wie sie sind.
   - Fenster (Groessentabelle, Story, Newsletter) rutschten von 100px
     LINKS herein und nach 80px RECHTS wieder hinaus. Das sieht nach
     Baukasten aus.
   - Die Sprach- und Landfenster blendeten in 0,15 s hart auf.

   Neu: beide steigen mit der Kurve von "Zur Kasse" auf --
   cubic-bezier(.16,1,.3,1), 0,42 s hinein, 0,22 s wieder hinaus.
   Beim Popover bewegt sich nur die Innenflaeche; die aeussere
   Verschiebung gehoert der Positionierung und wird nicht angefasst.
   ========================================================================== */
(function () {
  var KURVE_AUF = 'cubic-bezier(.16, 1, .3, 1)';
  var KURVE_ZU  = 'cubic-bezier(.4, 0, 1, 1)';

  /* Marvin: "der eingang ist komisch -- nur beim zweiten mal, beim
     ersten nicht."
     Genau das Muster eines Abbruchs vor dem Neustart: die vorige
     Schliess-Animation haelt ihren Endwert fest (fill: both). Bricht
     man sie ab, faellt das Element fuer einen Bildlauf auf seinen
     Ruhewert -- also sichtbar in die offene Lage -- und springt erst
     dann an den Anfang der neuen Bewegung. Beim ersten Oeffnen gibt es
     nichts abzubrechen, deshalb fiel es nur ab dem zweiten Mal auf.
     Also: Anfangslage zuerst als Inline-Stil setzen, dann abbrechen. */
  function lauf(el, rahmen, dauer, kurve) {
    if (!el || typeof el.animate !== 'function') return null;
    var anfang = rahmen[0], schluessel = [];
    for (var k in anfang) {
      if (Object.prototype.hasOwnProperty.call(anfang, k)) {
        schluessel.push(k);
        try { el.style.setProperty(k, anfang[k]); } catch (e) {}
      }
    }
    if (el.__axLauf) { try { el.__axLauf.cancel(); } catch (e) {} }
    var a = el.animate(rahmen, { duration: dauer, easing: kurve, fill: 'both' });
    el.__axLauf = a;
    a.finished.then(function () {
      /* Die Animation haelt den Endwert; der Inline-Stil darf weg. */
      if (el.__axLauf === a) schluessel.forEach(function (k) { el.style.removeProperty(k); });
    }).catch(function () {});
    return a;
  }

  /* Das Theme erwartet ein Objekt mit .complete() und await-bar. */
  function huelle(animationen) {
    var echte = animationen.filter(Boolean);
    var fertig = Promise.all(echte.map(function (a) {
      return a.finished.catch(function () {});
    }));
    return {
      complete: function () {
        echte.forEach(function (a) { try { a.finish(); } catch (e) {} });
      },
      then: function (f, g) { return fertig.then(f, g); }
    };
  }

  var HINEIN = [
    { opacity: 0, transform: 'translateY(1.6rem) scale(.984)' },
    { opacity: 1, transform: 'translateY(0) scale(1)' }
  ];
  var HINAUS = [
    { opacity: 1, transform: 'translateY(0) scale(1)' },
    { opacity: 0, transform: 'translateY(.8rem) scale(.992)' }
  ];

  function ersetze(name, auf, zu) {
    var K = customElements.get(name);
    if (!K || !K.prototype) return false;
    var altAuf = K.prototype.animateDialogOpen;
    var altZu  = K.prototype.animateDialogClose;
    /* Eigene Marke pruefen, nicht die geerbte -- sonst laesst sich ein
       Kind eines schon gepatchten Elements nie mehr selbst patchen. */
    if (Object.prototype.hasOwnProperty.call(K.prototype, '__axBewegung')) return true;
    K.prototype.__axBewegung = true;
    K.prototype.animateDialogOpen = function () {
      try { return auf.call(this); } catch (e) { return altAuf.call(this); }
    };
    K.prototype.animateDialogClose = function () {
      try { return zu.call(this); } catch (e) { return altZu.call(this); }
    };
    return true;
  }

  function bereit() {
    /* ---- Fenster: Groessentabelle, Story, Newsletter, Alterspruefung ---- */
    ersetze('hdt-modal',
      function () { return huelle([lauf(this.dialog, HINEIN, 420, KURVE_AUF)]); },
      function () { return huelle([lauf(this.dialog, HINAUS, 220, KURVE_ZU)]); }
    );

    /* ---- Sprache und Land ----------------------------------------------
       Die aeussere Verschiebung des Popovers stellt seine Lage ein.
       Deshalb traegt der Rahmen nur die Deckkraft, die Bewegung liegt
       auf der Innenflaeche. Ohne Innenflaeche faellt alles auf den
       Rahmen zurueck -- die zentrierten Sprachfenster stehen per CSS
       fest, da stoert es nicht. */
    /* Das Sortierfenster ist kein Popover mehr, sondern eine Karte wie
       der Filter -- also bekommt es auch dessen Bewegung: ein kurzer
       Versatz plus Aufblenden, gleiche Zeiten, gleiche Kurve. Marvin:
       "bau das pop up von sortieren genau gleich wie das von filtern
       inklusive animation". */
    function istSortier(d) {
      return d && !/Country$|Language$/.test(d.id || '');
    }

    /* 1:1 statt nachgebaut: das Sortierfenster bekommt die Klassen des
       Filter-Schubfachs, damit das Theme es mit seinem eigenen CSS
       zeichnet -- gleiche Kanten, gleiche Polster, gleiche Rundung.
       Marvin: "bau mir sortieren 1 zu 1 nach wie filtern." */
    function alsFilterKleiden(d) {
      if (!d || d.__axFilterKleid) return;
      d.__axFilterKleid = true;
      /* Die Popover-Klassen muessen WEG, sonst ueberschreiben sie das
         Schubfach-CSS: mit ihnen blieb der Koerper durchsichtig und das
         Polster bei 0. Ohne sie stimmt alles auf Anhieb -- gemessen
         gegen den Filter: Polster 15px, Koerper navy, Rundung 8px. */
      ['hdt-popover', 'hdt-popover-u', 'hdt-popover-u--no-padding',
       'hdt-dropdown', 'hdt-popover--sorting-options']
        .forEach(function (k) { d.classList.remove(k); });
      ['hdt-dialog', 'hdt-drawer', 'hdt-drawer--filters', 'hdt-drawer--indent', 'hdt-drawer--blur']
        .forEach(function (k) { d.classList.add(k); });
      if (!d.getAttribute('pos')) d.setAttribute('pos', 'left');
      var koerper = d.querySelector('.hdt-popover__body');
      if (koerper) koerper.classList.add('hdt-drawer_wrapper');
      var kopf = d.querySelector('.hdt-popover__header');
      if (kopf) kopf.classList.add('hdt-drawer__header');
      var liste = d.querySelector('.hdt-popover__inner');
      if (liste) liste.classList.add('hdt-drawer__inner', 'hdt-scrollbar');
      d.classList.add('ax-sortier');

      /* Der Zipfel und der Popover-Pfeil gehoeren zu einem Fenster, das
         von einem Knopf haengt -- hier ist es ein Schubfach. Weg damit. */
      var zipfel = d.querySelector('.hdt-popover-u__top');
      if (zipfel) zipfel.remove();
      var pfeil = d.querySelector('.hdt-popover__arrow');
      if (pfeil) pfeil.remove();

      /* Das Kreuz sitzt beim Filter IN der Kopfzeile. Hier haengt es als
         Kind des Fensters -- also umhaengen, dann traegt es dieselbe
         Gestaltung wie dort. */
      var kopf2 = d.querySelector('.hdt-drawer__header');
      var kreuz = d.querySelector('button[ref="closeButton"]');
      if (kopf2 && kreuz && kreuz.parentElement !== kopf2) {
        kopf2.appendChild(kreuz);
        kreuz.classList.add('hdt-close-dialog-btn');
      }
    }
    ersetze('hdt-popover',
      function () {
        var d = this.dialog;
        if (istSortier(d)) {
          alsFilterKleiden(d);
          return huelle([lauf(d,
            [{ opacity: '0', transform: 'translate3d(-3.2rem, 0, 0)' },
             { opacity: '1', transform: 'translate3d(0, 0, 0)' }],
            420, KURVE_AUF)]);
        }
        var kern = d.querySelector('.hdt-popover__inner') || d.firstElementChild;
        var schritte = [lauf(d, [{ opacity: 0 }, { opacity: 1 }], 300, KURVE_AUF)];
        if (kern) schritte.push(lauf(kern, HINEIN, 420, KURVE_AUF));
        d.style.visibility = 'visible';
        return huelle(schritte);
      },
      function () {
        var d = this.dialog;
        if (istSortier(d)) {
          return huelle([lauf(d,
            [{ opacity: '1', transform: 'translate3d(0, 0, 0)' },
             { opacity: '0', transform: 'translate3d(-3.2rem, 0, 0)' }],
            220, KURVE_ZU)]);
        }
        var kern = d.querySelector('.hdt-popover__inner') || d.firstElementChild;
        var schritte = [lauf(d, [{ opacity: 1 }, { opacity: 0 }], 220, KURVE_ZU)];
        if (kern) schritte.push(lauf(kern, HINAUS, 220, KURVE_ZU));
        return huelle(schritte);
      }
    );

    /* Laptop (03.09.2026). Der fruehere Block haengte sich an
       hdt-popover-sorting -- das ist aber ein blosses HTMLElement ohne
       Dialogmethoden (facets.js), der Patch lief ins Leere. Das Fenster
       gehoert ab 768px dem <hdt-popover-sortby> (custom.js, erbt Popover
       aus global.js): Popover.show nimmt dialog.show() statt showModal(),
       sobald das Fenster breiter als minWidth (768) ist -- ohne Modal
       gibt es keinen Backdrop, kein scroll-lock, kein Esc, kein
       Aussenklick, und die klebende Kopfleiste legt sich ueber das Kreuz.
       Und isDesktop schaltet auf die eigene Aufklapp-Animation, an
       meinem Filter-Anzug vorbei. Beides abgeschaltet: minWidth
       unendlich -> immer Modal; isDesktop falsch -> derselbe Weg wie am
       Handy. Marvin: "das pop-up vom sortieren hat nicht die gleiche
       hintergrundunschaerfe, man kann es nicht rechts mit dem kreuz
       wegklicken -- gleiche funktionalitaet wie das filtern-pop-up." */
    customElements.whenDefined('hdt-popover-sortby').then(function () {
      var K = customElements.get('hdt-popover-sortby');
      if (!K || !K.prototype || Object.prototype.hasOwnProperty.call(K.prototype, '__axLaptop')) return;
      K.prototype.__axLaptop = true;
      Object.defineProperty(K.prototype, 'isDesktop', { get: function () { return false; }, configurable: true });
      Object.defineProperty(K.prototype, 'minWidth',  { get: function () { return Infinity; }, configurable: true });
    });

    /* Sicherheitsnetz: nicht erst beim Oeffnen umkleiden -- der
       Tablet-Weg lief an allen Animations-Haken vorbei und liess einen
       22px-Streifen stehen. Beim Laden werden ALLE Sortierfenster
       sofort zum Filter-Schubfach, egal wer sie spaeter oeffnet. */
    function kleideAlleSortierfenster() {
      document.querySelectorAll('dialog.hdt-popover--sorting-options').forEach(alsFilterKleiden);
    }
    /* 21.10.2026: Erst umkleiden, wenn facets.js sein <hdt-popover-sorting>
       verbunden hat. Dessen connectedCallback sucht ".hdt-popover" und haengt
       dort den Hoerer fuer die Sortier-Auswahl an. War die Klasse beim Laden
       schon weg, brach es mit einem Fehler ab und die Auswahl im Menue tat
       nichts. Nach dem Neuzeichnen (Sortieren/Filtern) die neuen Fenster
       ebenfalls umkleiden -- facets.js hat sie dann schon verbunden. */
    function nachFacets() {
      kleideAlleSortierfenster();
      setTimeout(kleideAlleSortierfenster, 1500);
      if (!document.querySelector('hdt-popover-sorting')) return;
      var wartet = false;
      new MutationObserver(function () {
        if (wartet) return;
        wartet = true;
        setTimeout(function () { wartet = false; kleideAlleSortierfenster(); }, 50);
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
    if (document.querySelector('hdt-popover-sorting') && !customElements.get('hdt-popover-sorting')) {
      Promise.race([
        customElements.whenDefined('hdt-popover-sorting'),
        new Promise(function (r) { setTimeout(r, 5000); })
      ]).then(nachFacets);
    } else {
      nachFacets();
    }
  }

  if (customElements.get('hdt-modal')) { bereit(); return; }
  var versuche = 0;
  var takt = setInterval(function () {
    if (customElements.get('hdt-modal') || ++versuche > 80) { clearInterval(takt); bereit(); }
  }, 50);
})();

/* ==========================================================================
   ATHLIX — Schubladen gleiten, statt freigewischt zu werden
   ==========================================================================
   Marvin: "die animationen bei den pop ups, warenkorb und suchen, sind
   nicht smooth, wie sie eingeblendet werden und ausgeblendet."

   Der Grund steht in global.js: Warenkorb und Suche tragen beide
   `hdt-drawer--indent`. Fuer diese Sorte faehrt das Theme KEINE
   Bewegung, sondern eine `clip-path`-Kante ueber die stehende
   Flaeche -- und blendet die Kinder erst danach in 0,15 s ein. Es
   sieht deshalb aus, als springe die Schublade an ihren Platz und
   werde nachtraeglich aufgedeckt.

   Jetzt gleitet die Innenflaeche wirklich: `translate3d` von der
   Kante herein, mit derselben Kurve wie ueberall. Der Zuschnitt wird
   ausdruecklich geloescht -- sonst steht der letzte Wischwert als
   Inline-Stil im Weg. Das Menue behaelt seine eigene Bewegung, es
   ueberschreibt die Methoden selbst.
   ========================================================================== */
(function () {
  var KURVE_AUF = 'cubic-bezier(.16, 1, .3, 1)';
  var KURVE_ZU  = 'cubic-bezier(.4, 0, 1, 1)';

  /* Anfangslage zuerst inline setzen, dann die alte Animation
     abbrechen -- sonst zeigt die Schublade fuer einen Bildlauf ihre
     offene Lage, bevor sie von der Kante hereinfaehrt. Das war das
     Zucken ab dem zweiten Oeffnen. */
  function lauf(el, rahmen, dauer, kurve) {
    if (!el || typeof el.animate !== 'function') return null;
    var anfang = rahmen[0], schluessel = [];
    for (var k in anfang) {
      if (Object.prototype.hasOwnProperty.call(anfang, k)) {
        schluessel.push(k);
        try { el.style.setProperty(k, anfang[k]); } catch (e) {}
      }
    }
    if (el.__axSchub) { try { el.__axSchub.cancel(); } catch (e) {} }
    var a = el.animate(rahmen, { duration: dauer, easing: kurve, fill: 'both' });
    el.__axSchub = a;
    a.finished.then(function () {
      if (el.__axSchub === a) schluessel.forEach(function (k) { el.style.removeProperty(k); });
    }).catch(function () {});
    return a;
  }

  function huelle(animationen) {
    var echte = animationen.filter(Boolean);
    var fertig = Promise.all(echte.map(function (a) {
      return a.finished.catch(function () {});
    }));
    return {
      complete: function () {
        echte.forEach(function (a) { try { a.finish(); } catch (e) {} });
      },
      then: function (f, g) { return fertig.then(f, g); }
    };
  }

  /* Marvin: "bei sprache und groessentabelle ist es nice, aber search
     und drawer schauen ab dem zweiten oeffnen nicht gut aus."
     Der volle Kantenschub (100% der Breite) ist raus. Die Schubladen
     bekommen dieselbe Bewegung wie die Fenster, die ihm gefallen:
     ein kleiner Versatz aus der jeweiligen Kante plus Aufblenden.
     Kurze Wege komponieren sauberer und zeigen die Schwaeche des
     langen Schubs erst gar nicht. */
  function weg(seite) {
    if (seite === 'right')  return 'translate3d(3.2rem, 0, 0)';
    if (seite === 'bottom') return 'translate3d(0, 3.2rem, 0)';
    if (seite === 'top')    return 'translate3d(0, -3.2rem, 0)';
    return 'translate3d(-3.2rem, 0, 0)';
  }

  function teile(d) {
    var indent = d.classList.contains('hdt-drawer--indent');
    var ziel = indent ? (d.firstElementChild || d) : d;
    return { indent: indent, ziel: ziel };
  }

  function bereit() {
    var K = customElements.get('hdt-drawer');
    if (!K || !K.prototype || K.prototype.__axSchublade) return;
    var altAuf = K.prototype.animateDialogOpen;
    var altZu  = K.prototype.animateDialogClose;
    K.prototype.__axSchublade = true;

    K.prototype.animateDialogOpen = function () {
      try {
        var d = this.dialog, t = teile(d);
        /* Der Wischwert des Themes steht als Inline-Stil und wuerde die
           Flaeche unsichtbar halten. */
        t.ziel.style.clipPath = 'none';
        t.ziel.style.willChange = 'transform, opacity';
        var a = lauf(t.ziel,
          [{ transform: weg(this.pos), opacity: '0' },
           { transform: 'translate3d(0, 0, 0)', opacity: '1' }],
          420, KURVE_AUF);
        var h = huelle([a]);
        h.then(function () { t.ziel.style.willChange = ''; });
        return h;
      } catch (e) { return altAuf.call(this); }
    };

    K.prototype.animateDialogClose = function () {
      try {
        var d = this.dialog, t = teile(d);
        t.ziel.style.clipPath = 'none';
        t.ziel.style.willChange = 'transform, opacity';
        var a = lauf(t.ziel,
          [{ transform: 'translate3d(0, 0, 0)', opacity: '1' },
           { transform: weg(this.pos), opacity: '0' }],
          220, KURVE_ZU);
        var h = huelle([a]);
        h.then(function () { t.ziel.style.willChange = ''; });
        return h;
      } catch (e) { return altZu.call(this); }
    };
  }

  if (customElements.get('hdt-drawer')) { bereit(); return; }
  var versuche = 0;
  var takt = setInterval(function () {
    if (customElements.get('hdt-drawer') || ++versuche > 80) { clearInterval(takt); bereit(); }
  }, 50);
})();

/* ==========================================================================
   ATHLIX — Beschriftung im Live-Chat-Knopf
   ==========================================================================
   Der Knopf selbst laesst sich von aussen malen, er traegt
   `part="activator"`. Seine Beschriftung nicht: das Schatten-Blatt von
   Shopify Inbox setzt auf `.activator__label` eine eigene Farbe, und
   die erbt nichts. Auf dem navy Knopf stand die Schrift deshalb
   schwarz.

   Marvin: "shopify inbox text nach dem man den chat wieder verlaesst
   schwarz, soll weiss sein." Beim Oeffnen raeumt die App ihren
   Schatten-Baum leer und baut ihn beim Schliessen neu auf -- unser
   Blatt ueberlebt zwar, steht danach aber nicht mehr zuletzt. Deshalb
   zwei Vorkehrungen: die Waehler tragen ein Glied mehr, und ein
   Beobachter schiebt das Blatt nach jedem Umbau wieder ans Ende.
   ========================================================================== */
(function () {
  var REGELN = [
    '.activator .activator__label,',
    '.activator .activator__icon,',
    '.activator .activator__icon svg,',
    '.activator .activator__icon svg path {',
    '  color: #ffffff !important;',
    '  fill: currentColor !important;',
    '  font-family: "Athlix Performance Text", sans-serif !important;',
    '  font-weight: 800 !important;',
    '  letter-spacing: .12em !important;',
    '  text-transform: uppercase !important;',
    '}',
    '.activator:hover .activator__label,',
    '.activator:hover .activator__icon,',
    '.activator:hover .activator__icon svg,',
    '.activator:hover .activator__icon svg path {',
    '  color: #132251 !important;',
    '}',
    '.activator .activator__indicator { background: #ffffff !important; }',
    /* Auffangnetz: falls die App den Knopf mit anderen Klassen neu
       aufbaut, greift wenigstens dieser Waehler -- er steht zuletzt. */
    '.activator, .activator * { color: #ffffff !important; }',
    '.activator:hover, .activator:hover * { color: #132251 !important; }',
    /* Der Knopf stand unten LINKS und lag damit genau auf den beiden
       Held-Knoepfen der Startseite ("Performance" war verdeckt, gemessen
       auf 1440, 834 und 390), auf der Produktseite auf dem Titel und in
       der Kollektion auf einem Preis. Die App verankert ihn ueber die
       Huelle `.activator-nudge--left` (left: 20px). Sie steht in
       adoptedStyleSheets, unser Blatt haengt dahinter -- also duerfen
       wir sie hier umhaengen. Unten rechts verdeckt er nichts. */
    '.activator-nudge, .activator-nudge--left {',
    '  left: auto !important;',
    '  right: 20px !important;',
    '}',
    /* Auf dem Handy ist die Zeile so schmal, dass der Knopf rechts auf
       "Essentials" fiel (gemessen 390px: Knopf ab x242, Essentials bis
       x302). Dort sitzt er deshalb ganz unten -- unter beiden
       Held-Knoepfen, die bei y783 enden. */
    '@media (max-width: 767px) {',
    '  .activator-nudge, .activator-nudge--left {',
    '    bottom: 16px !important;',
    '  }',
    '}'
  ].join('\n');

  var laeuft = false;

  function setze() {
    var w = document.querySelector('shopify-chat');
    if (!w || !w.shadowRoot) return false;
    var sr = w.shadowRoot;
    if (laeuft) return true;
    laeuft = true;
    try {
      /* Entscheidend: ein <style> IM Schatten-Baum steht in der
         Rangfolge IMMER VOR den `adoptedStyleSheets` -- und genau dort
         haelt Shopify Inbox seine Regeln. Deshalb verlor unsere Farbe,
         obwohl das Blatt zuletzt im Baum stand. Wir haengen uns
         stattdessen selbst hinten an die adoptierten Blaetter. */
      if (typeof CSSStyleSheet === 'function' && 'adoptedStyleSheets' in sr) {
        if (!w.__axBlatt) {
          try {
            w.__axBlatt = new CSSStyleSheet();
            w.__axBlatt.replaceSync(REGELN);
          } catch (e) { w.__axBlatt = null; }
        }
        if (w.__axBlatt) {
          var liste = Array.prototype.slice.call(sr.adoptedStyleSheets || []);
          var drin = liste.indexOf(w.__axBlatt);
          if (drin !== liste.length - 1) {
            if (drin > -1) liste.splice(drin, 1);
            liste.push(w.__axBlatt);
            sr.adoptedStyleSheets = liste;
          }
        }
      }
      /* Zusaetzlich weiter als <style> im Baum -- schadet nicht und
         faengt Browser ohne adoptedStyleSheets. */
      var blatt = sr.querySelector('style[data-athlix]');
      if (!blatt) {
        blatt = document.createElement('style');
        blatt.setAttribute('data-athlix', 'chat');
        blatt.textContent = REGELN;
      }
      if (sr.lastElementChild !== blatt) sr.appendChild(blatt);
      if (!w.__axBeobachter) {
        w.__axBeobachter = new MutationObserver(function () { setze(); });
        w.__axBeobachter.observe(sr, { childList: true, subtree: true });
      }
    } finally { laeuft = false; }
    return true;
  }

  if (!setze()) {
    var versuche = 0;
    var takt = setInterval(function () {
      if (setze() || ++versuche > 120) clearInterval(takt);
    }, 500);
  }
  /* Falls die App ihr Element spaeter ganz austauscht. */
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () { setze(); })
      .observe(document.body || document.documentElement, { childList: true });
  }
})();

/* ==========================================================================
   ATHLIX — Das Bewerbungsfenster bewegt sich wie die anderen Fenster
   ==========================================================================
   Marvin: "mach karriereformular auch so animiert."
   Es laeuft nicht ueber die Fenster-Klassen des Themes, sondern ueber
   blankes showModal(). Bisher trug CSS die Bewegung (@starting-style),
   was nicht in jedem Browser greift. Jetzt dieselbe Bewegung wie bei
   Sprache und Groessentabelle -- gleiche Kurve, gleiche Zeiten,
   gleicher Weg.
   ========================================================================== */
(function () {
  var KURVE_AUF = 'cubic-bezier(.16, 1, .3, 1)';
  var KURVE_ZU  = 'cubic-bezier(.4, 0, 1, 1)';
  var HINEIN = [
    { opacity: '0', transform: 'translateY(1.6rem) scale(.984)' },
    { opacity: '1', transform: 'translateY(0) scale(1)' }
  ];
  var HINAUS = [
    { opacity: '1', transform: 'translateY(0) scale(1)' },
    { opacity: '0', transform: 'translateY(.8rem) scale(.992)' }
  ];

  function bewege(el, rahmen, dauer, kurve) {
    if (!el || typeof el.animate !== 'function') return null;
    var anfang = rahmen[0], schluessel = [];
    for (var k in anfang) {
      if (Object.prototype.hasOwnProperty.call(anfang, k)) {
        schluessel.push(k);
        try { el.style.setProperty(k, anfang[k]); } catch (e) {}
      }
    }
    if (el.__axJob) { try { el.__axJob.cancel(); } catch (e) {} }
    var a = el.animate(rahmen, { duration: dauer, easing: kurve, fill: 'both' });
    el.__axJob = a;
    a.finished.then(function () {
      if (el.__axJob === a) schluessel.forEach(function (k) { el.style.removeProperty(k); });
    }).catch(function () {});
    return a;
  }

  function haenge() {
    var f = document.getElementById('axBewerbung');
    if (!f || f.__axBewegt) return !!f;
    f.__axBewegt = true;

    var altAuf = f.showModal.bind(f);
    f.showModal = function () {
      altAuf();
      bewege(f, HINEIN, 420, KURVE_AUF);
    };

    /* Das Abschnitts-Skript setzt beim Schliessen die Klasse und wartet
       220 ms. Genau darauf legen wir den Ausgang. */
    new MutationObserver(function () {
      if (f.classList.contains('ax-jobs__dialog--zu')) bewege(f, HINAUS, 220, KURVE_ZU);
    }).observe(f, { attributes: true, attributeFilter: ['class'] });
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', haenge);
  } else if (!haenge()) {
    var n = 0;
    var takt = setInterval(function () { if (haenge() || ++n > 40) clearInterval(takt); }, 250);
  }
})();

/* ==========================================================================
   ATHLIX — Pfeile fuer die Wischspuren
   ==========================================================================
   Marvin: "die pfeile fehlen hier" (Drei Gruende) und "unsere werte und
   team sollten slider sein mit pfeilen".
   Ein Baustein fuer alle: er haengt zwei Knoepfe neben die Spur, rollt
   um genau eine Karte weiter und blendet sich an den Enden aus. Die
   Form ist die der uebrigen Slider-Pfeile -- weisser Ring, navy Zeichen.
   ========================================================================== */
(function () {
  var SPUREN = ['.ax-cards__grid', '.ax-werte__raster', '.ax-team__raster', '.ax-vs__grid'];

  function knopf(richtung, spur) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ax-spur__pfeil ax-spur__pfeil--' + richtung;
    b.setAttribute('aria-label', richtung === 'vor' ? 'Weiter' : 'Zurück');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
      + '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2"'
      + ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
    b.addEventListener('click', function () {
      var karte = spur.children[0];
      var schritt = karte ? karte.getBoundingClientRect().width + 12 : spur.clientWidth * 0.8;
      spur.scrollBy({ left: richtung === 'vor' ? schritt : -schritt, behavior: 'smooth' });
    });
    return b;
  }

  function ruesteAus(spur) {
    if (!spur || spur.__axPfeile) return;
    /* Nur wo es auch etwas zu rollen gibt. */
    if (spur.scrollWidth <= spur.clientWidth + 8) return;
    spur.__axPfeile = true;

    var huelle = spur.parentElement;
    if (!huelle) return;
    if (getComputedStyle(huelle).position === 'static') huelle.style.position = 'relative';
    huelle.classList.add('ax-spur__huelle');

    var zurueck = knopf('zurueck', spur), vor = knopf('vor', spur);
    huelle.appendChild(zurueck);
    huelle.appendChild(vor);

    function stand() {
      var rest = spur.scrollWidth - spur.clientWidth;
      zurueck.hidden = spur.scrollLeft <= 4;
      vor.hidden = spur.scrollLeft >= rest - 4;
      /* Mitte der Spur, nicht der Huelle -- die Huelle kann auch den
         Titel enthalten, dann haengt der Pfeil sonst zu hoch. */
      var mitte = (spur.getBoundingClientRect().top - huelle.getBoundingClientRect().top)
        + spur.offsetHeight / 2;
      zurueck.style.setProperty('--ax-spur-mitte', mitte + 'px');
      vor.style.setProperty('--ax-spur-mitte', mitte + 'px');
    }
    spur.addEventListener('scroll', stand, { passive: true });
    window.addEventListener('resize', stand);
    stand();
  }

  function durchgang() {
    SPUREN.forEach(function (w) {
      document.querySelectorAll(w).forEach(ruesteAus);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', durchgang);
  } else {
    durchgang();
  }
  /* Bilder und Schriften aendern die Breiten -- nach dem Laden nochmal. */
  window.addEventListener('load', durchgang);
  setTimeout(durchgang, 1200);
})();

/* ==========================================================================
   ATHLIX — Kopfzeile nach Dialogen heilen
   ==========================================================================
   Marvin (iPhone): "wenn ich den filter oeffne, passiert das mit dem
   hintergrundbild, darf nicht sein." Auf iOS bleibt der Kopf nach dem
   Schliessen von Filter/Sortieren im Scroll-Zustand haengen
   (scrolled-past-header + sticky), obwohl die Seite oben steht -- der
   Banner rutscht dann unter den Kopf statt dahinter. Headless ist das
   nicht nachstellbar, darum die Versicherung: steht die Seite oben,
   wird nach jedem Dialog-Schliessen der Oben-Zustand erzwungen.
   ========================================================================== */
(function () {
  var SCROLL_KLASSEN = ['scrolled-past-header', 'shopify-section-header-sticky', 'animate'];

  function heile() {
    if (window.scrollY > 8) return;
    document.querySelectorAll('.hdt-section-header-group').forEach(function (kopf) {
      SCROLL_KLASSEN.forEach(function (k) { kopf.classList.remove(k); });
      kopf.classList.add('header-near-top');
    });
  }

  /* close blubbert nicht -- am Dokument mit capture abfangen. */
  document.addEventListener('close', function (e) {
    if (e.target && e.target.tagName === 'DIALOG') {
      setTimeout(heile, 60);
      setTimeout(heile, 400); /* falls der Sticky-Code nochmal nachzieht */
    }
  }, true);

  /* Und als zweites Netz: landet die Seite oben, stimmt der Zustand. */
  window.addEventListener('scroll', function () {
    if (window.scrollY <= 8) heile();
  }, { passive: true });
})();


/* ==========================================================================
   ATHLIX — Das Kopfmenue oeffnet beim Ueberfahren
   ==========================================================================
   Marvin (05.09.2026): "mach das menue so, dass man beim hovern die
   unterseiten angezeigt bekommt -- eleganteres menue."

   Das Theme kann das im Ansatz: `hdt-header-menu` liest ein Attribut
   `event`, und `HeaderMenu.connectedCallback` in global.js hat einen
   Hover-Zweig -- der ist dort aber auskommentiert, ebenso die
   zugehoerige Einstellung im Schema des Menue-Bausteins. Das Attribut
   steht jetzt auf `hover` (blocks/_header-menu.liquid), die Mechanik
   steht hier.

   Geoeffnet wird ueber einen Klick auf das `summary` -- dann laeuft
   dieselbe Strecke wie sonst (Kulisse, Esc, Klick nach aussen,
   Aufraeumen). Ein echter Klick auf einen bereits offenen Punkt fuehrt
   weiterhin auf seine Seite; das erledigt `_onSummaryClicked` selbst.

   Beim Verlassen wird mit kurzer Verzoegerung geschlossen, damit der
   Weg von der Beschriftung hinunter in die Liste nicht abreisst.
   Geraete ohne Maus bleiben beim Klick: `matchMediaQuery('hover')` in
   global.js liefert dort `false`, und diese Schleife haengt sich nur
   an Zeiger, die wirklich schweben koennen.
   ========================================================================== */
(function () {
  var VERZUG = 180;

  function feinerZeiger() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function ruesteAus(el) {
    if (el.__axHover) return;
    if (el.getAttribute('event') !== 'hover') return;
    /* Nur die oberste Ebene. Die zweite Ebene traegt `pos2` und oeffnet
       weiterhin auf Klick -- dort ueberfaehrt man beim Zielen zu leicht
       den falschen Eintrag. */
    if (el.hasAttribute('pos2')) return;
    el.__axHover = true;

    var d = el.querySelector('details');
    var s = el.querySelector('summary');
    if (!d || !s) return;
    var takt = null;

    function auf() {
      clearTimeout(takt);
      /* Alle anderen zuerst schliessen, sonst stehen zwei Listen offen,
         wenn man waagrecht von einem Punkt zum naechsten faehrt. */
      document.querySelectorAll('hdt-header-menu[event="hover"]').forEach(function (n) {
        if (n === el) return;
        var nd = n.querySelector('details');
        if (nd && nd.open && n.closeMenu) { try { n.closeMenu(); } catch (e) {} }
      });
      if (!d.open) s.click();
    }
    function zu() {
      clearTimeout(takt);
      takt = setTimeout(function () {
        if (d.open && el.closeMenu) { try { el.closeMenu(); } catch (e) {} }
      }, VERZUG);
    }

    el.addEventListener('mouseenter', auf);
    el.addEventListener('mouseleave', zu);
    /* Mit der Tastatur bleibt alles beim Alten: Fokus oeffnet, das
       Theme schliesst beim Verlassen ueber `focusout`. */
    s.addEventListener('focus', function () { clearTimeout(takt); });
  }

  function durchgang() {
    if (!feinerZeiger()) return;
    document.querySelectorAll('hdt-header-menu').forEach(ruesteAus);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', durchgang);
  } else {
    durchgang();
  }
  window.addEventListener('load', durchgang);
  setTimeout(durchgang, 1200);
})();


/* ==========================================================================
   ATHLIX — Die Pfeile der Zeitleiste am Laptop
   ==========================================================================
   Marvin (05.09.2026): "hier fehlen die pfeile wie auf mobile."
   Der Abschnitt "Unsere Geschichte" zeigt vier Folien in einem Slider
   (Container 5448px auf 1344px Buehne) -- ohne Bedienung kommt man an
   den Folien zwei bis vier nicht vorbei.

   Die Knoepfe sind im Markup vorhanden, stehen aber auf `display: none`.
   Ueber CSS war das nicht zu heben: die Regel des Themes ist weder mit
   `element.matches()` aufzufinden noch mit `!important` und richtiger
   Klasse zu schlagen (verschachtelte Regel in base.css). Ein Inline-Stil
   am Element greift -- gemessen: die Pfeile stehen dann 44x44 links und
   rechts auf halber Bildhoehe, symmetrisch mit 56px Rand.

   Ab 1025px ueberall; darunter nur auf Medien und Community -- Marvin
   (08.09.2026): "der Bereich mit dem Slider ist nicht gut, so wie auf
   dem Rest der Website mit Pfeilen auf Mobile." Auf "Unsere Geschichte"
   bleiben sie am Handy aus, dort wollte er ausdruecklich durchwischen.
   ========================================================================== */
(function () {
  var MIT_PFEILEN_AM_HANDY = ['media_and_text_block_presse', 'media_and_text_block_community'];

  function amHandyErlaubt(nav) {
    var sek = nav.closest('.shopify-section');
    if (!sek) return false;
    return MIT_PFEILEN_AM_HANDY.some(function (schluessel) {
      return sek.id.indexOf(schluessel) >= 0;
    });
  }

  function zeige() {
    var schmal = window.innerWidth < 1025;
    document.querySelectorAll('.hdt-media-text-flat-slider .hdt-slider-nav').forEach(function (nav) {
      if (schmal && !amHandyErlaubt(nav)) return;
      /* Nur wo es auch etwas zu blaettern gibt. */
      var slider = nav.closest('.hdt-slider');
      var spur = slider && slider.querySelector('.hdt-slider__container');
      if (!spur || spur.scrollWidth <= spur.clientWidth + 8) return;
      nav.style.setProperty('display', 'flex', 'important');
      nav.querySelectorAll('button').forEach(function (b) {
        b.style.setProperty('display', 'grid', 'important');
        b.style.setProperty('opacity', '1', 'important');
        b.style.setProperty('visibility', 'visible', 'important');
        /* Am Handy stehen Bild und Text uebereinander; das Bild ist 200px
           hoch, also sitzen die Pfeile auf dessen Mitte statt ueber dem
           Text. Am Laptop bleibt es beim Mass des Themes. */
        if (schmal) {
          b.style.setProperty('top', '10rem', 'important');
          b.style.setProperty('translate', '0 -50%', 'important');
          b.style.setProperty('transform', 'none', 'important');
        } else {
          b.style.removeProperty('top');
          b.style.removeProperty('translate');
          b.style.removeProperty('transform');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zeige);
  } else {
    zeige();
  }
  window.addEventListener('load', zeige);
  window.addEventListener('resize', zeige);
  setTimeout(zeige, 1400);
})();


/* ==========================================================================
   ATHLIX — Das Abspielzeichen im Community-Karussell
   ==========================================================================
   Marvin (05.09.2026): "und das icon auf dem bild zu gross."

   Gemeint ist das runde Abspielzeichen mitten auf jedem Community-Video
   ("Aus der Community" auf der Startseite, "Getragen in Zuerich" auf den
   Produktseiten). Gemessen: Kreis 40px, Dreieck darin 28px -- es fuellt
   70 Prozent des Kreises, ueblich sind 40 bis 45. Auf der 250px breiten
   Karte sind das 16 Prozent der Breite, am Handy 21. Kein anderes Zeichen
   auf einem Bild im ganzen Theme kommt ueber 4,3 Prozent. Dazu ein
   Schlagschatten und ein rein schwarzes Dreieck -- beides gegen die
   Hausregeln.

   Der Gegner steht in einem konstruierten Stilblatt IM Schatten von
   <moast-play>, dreifach verschachtelt: moast-carousel > moast-media >
   moast-video > moast-play. Von aussen kommt da kein CSS hin, auch kein
   ::part. Also dasselbe Vorgehen wie beim Live-Chat: ein eigenes Blatt
   hinten an die adoptedStyleSheets jeder Wurzel.

   Wichtig: Aenderungen in einer verschachtelten Schattenwurzel melden
   sich NICHT beim Beobachter der aeusseren. Darum bekommt jede Wurzel
   ihren eigenen Beobachter -- sonst greifen die Regeln nur, wenn die
   Karten beim Laden zufaellig schon fertig sind.
   ========================================================================== */
(function () {
  var PLAY = [
    /* Kreis: 13,5 Prozent der Karte, nie unter 28 und nie ueber 34px. */
    '.pause-button-container {',
    '  width: 13.5% !important;',
    '  min-width: 28px !important;',
    '  max-width: 34px !important;',
    '}',
    /* Dreieck auf 46 Prozent des Kreises statt 70 -- und in Navy. */
    '.pause-button svg {',
    '  width: 46% !important;',
    '  fill: #132251 !important;',
    '}',
    '.pause-button, .pause-button:hover {',
    '  box-shadow: none !important;',
    '  background-color: rgba(255, 255, 255, .92) !important;',
    '}',
    '.pause-button:hover { transform: none !important; }'
  ].join('\n');

  var KARUSSELL = [
    /* Das Ton-aus-Zeichen oben rechts liegt ebenfalls auf dem Bild und
       war mit 32px aussen genauso schwer. Jetzt 16 plus 6 Polster. */
    '.carousel moast-mute {',
    '  width: 16px !important;',
    '  height: 16px !important;',
    '  padding: 6px !important;',
    '}',
    '.carousel__prev, .carousel__next,',
    '.carousel__prev:hover, .carousel__next:hover {',
    '  box-shadow: none !important;',
    '}'
  ].join('\n');

  var blattPlay = null;
  var blattKarussell = null;
  var beobachtet = (typeof WeakSet === 'function') ? new WeakSet() : null;

  function neuesBlatt(regeln) {
    if (typeof CSSStyleSheet !== 'function') return null;
    try {
      var b = new CSSStyleSheet();
      b.replaceSync(regeln);
      return b;
    } catch (e) { return null; }
  }

  /* Haengt das Blatt ans Ende der adoptierten Blaetter. Ist es schon
     drin, aber nicht zuletzt, wandert es nach hinten -- die App baut
     ihre Karten beim Blaettern neu auf. */
  function anhaengen(wurzel, blatt, regeln) {
    if (!wurzel) return;
    if (blatt) {
      try {
        var liste = Array.prototype.slice.call(wurzel.adoptedStyleSheets || []);
        var drin = liste.indexOf(blatt);
        if (drin !== liste.length - 1) {
          if (drin > -1) liste.splice(drin, 1);
          liste.push(blatt);
          wurzel.adoptedStyleSheets = liste;
        }
        return;
      } catch (e) { /* faellt durch auf den <style>-Weg */ }
    }
    if (!wurzel.querySelector('style[data-athlix="moast"]')) {
      var st = document.createElement('style');
      st.setAttribute('data-athlix', 'moast');
      st.textContent = regeln;
      wurzel.appendChild(st);
    }
  }

  function beobachte(wurzel) {
    if (!beobachtet || beobachtet.has(wurzel)) return;
    if (typeof MutationObserver !== 'function') return;
    beobachtet.add(wurzel);
    new MutationObserver(function () { setze(); })
      .observe(wurzel, { childList: true, subtree: true });
  }

  function durchlaufen(wurzel) {
    beobachte(wurzel);
    var kinder = wurzel.querySelectorAll('*');
    for (var i = 0; i < kinder.length; i++) {
      var el = kinder[i];
      if (!el.shadowRoot) continue;
      if (el.tagName.toLowerCase() === 'moast-play') {
        if (!blattPlay) blattPlay = neuesBlatt(PLAY);
        anhaengen(el.shadowRoot, blattPlay, PLAY);
      }
      durchlaufen(el.shadowRoot);
    }
  }

  function setze() {
    var karussells = document.querySelectorAll('moast-carousel');
    var gesetzt = false;
    for (var i = 0; i < karussells.length; i++) {
      var k = karussells[i];
      if (!k.shadowRoot) continue;
      gesetzt = true;
      if (!blattKarussell) blattKarussell = neuesBlatt(KARUSSELL);
      anhaengen(k.shadowRoot, blattKarussell, KARUSSELL);
      durchlaufen(k.shadowRoot);
    }
    return gesetzt;
  }

  /* Erster Versuch sofort, dann im Takt -- der Abschnitt laedt oft erst
     beim Scrollen nach. */
  var versuche = 0;
  var takt = setInterval(function () {
    setze();
    if (++versuche > 120) clearInterval(takt);
  }, 500);
  setze();
})();

/* ==========================================================================
   ATHLIX — Bundle unter die Vertrauenszeile, eingeklappt (09.09.2026)
   ==========================================================================
   Die Bundle-App (Profit Pumper) haengt ihr Fenster per Skript als
   direktes Kind in den Kaufknopf-Block, gleich hinter das Formular --
   das Template hat keinen Einfluss darauf. Folge auf der Live-Seite:
   ein 612px hohes Fenster mit zweitem "In den Warenkorb" zwischen
   Knopf und Lieferzeile; Lieferzeile und Vertrauenszeile lagen 800px
   unter dem Knopf, auf dem Handy drei Bildschirme.

   Hier wird das Fenster in einen eigenen Behaelter hinter der
   Vertrauenszeile (.ax-trust) umgehaengt, mit Kopfzeile zum Auf- und
   Zuklappen. Der Behaelter entsteht per JS und traegt data-type
   "ax-bundle" -- mit Absicht kein Liquid-Block: beim Variantenwechsel
   ersetzt global.js (update_product_info_fn) alle Bloecke der Typen
   price, badges, sku, inventory, payment-terms, pickup-availability und
   liquid per replaceWith. Ein Liquid-Block als Behaelter verschwaende
   also samt App-Fenster. Aus demselben Grund haengen Klick und
   Sichtbarkeit des Preis-Hinweises (.ax-bh, ein Liquid-Block) hier
   zusaetzlich am Dokument: nach dem Tausch hat der Block sein eigenes
   Skript nicht mehr.

   Stil: assets/athlix-ui.css, Abschnitt "Kaufbereich: Bundle".
   ========================================================================== */
(function () {
  'use strict';

  var buy = document.querySelector('.hdt-product__buy-buttons');
  if (!buy) return;
  var info = buy.closest('.hdt-product__info-container') || buy.parentElement;
  var en = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
  /* Erklaerung kurz halten: "Mit Driven Pace – Performance Shorts" passt
     am Handy in eine Zeile, mit "kombinieren" dahinter wuerde sie
     umbrechen und die Kopfzeile auf drei Zeilen wachsen. */
  var T = en
    ? { titel: 'Buy as a bundle and save 10%', kurz: 'Bundle: save 10%', sub: 'Combine this piece with a matching one', mit: 'With ', ende: '', auf: 'View', zu: 'Close' }
    : { titel: 'Als Bundle kaufen und 10% sparen', kurz: 'Bundle: 10% sparen', sub: 'Kombiniere dieses Piece mit einem passenden', mit: 'Mit ', ende: '', auf: 'Ansehen', zu: 'Schliessen' };

  var box = null, head = null, body = null, sub = null, cta = null, thumbs = null, preisEl = null;

  /* Shop-CDN-Bild auf Vorschaugroesse: die App liefert 4000px-Originale. */
  function klein(u) {
    if (!/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=160');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function bauen() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'hdt-product-info__item ax-bundle';
    box.setAttribute('data-type', 'ax-bundle');
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="ax-bundle__head" aria-expanded="false" aria-controls="ax-bundle-body">' +
        /* Marvin (09.09.): "bundle noch etwas besser ersichtlich, momentan
           geht es unter" -- darum links die beiden Produktbilder aus dem
           App-Fenster (die Marke "-10%" weicht ihnen, sobald Bilder da
           sind), im Text der Bundle-Preis, rechts die gefuellte Pille. */
        '<span class="ax-bundle__thumbs" aria-hidden="true"></span>' +
        '<span class="ax-bundle__tag">–10%</span>' +
        '<span class="ax-bundle__txt"></span>' +
        /* Marvin (09.09.): "es muss einfach klar sein, dass man draufklicken
           kann" -- darum rechts eine beschriftete Pille ("Ansehen" /
           "Schliessen" mit Pfeil) statt eines stummen Plus-Rings. */
        '<span class="ax-bundle__cta"><span class="ax-bundle__cta-tx"></span>' +
          '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<path d="M2.5 4.5 6 8l3.5-3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
      '</button>' +
      '<div class="ax-bundle__body" id="ax-bundle-body" hidden></div>';
    head = box.querySelector('.ax-bundle__head');
    body = box.querySelector('.ax-bundle__body');
    cta = box.querySelector('.ax-bundle__cta-tx');
    cta.textContent = T.auf;
    thumbs = box.querySelector('.ax-bundle__thumbs');
    var txt = box.querySelector('.ax-bundle__txt');
    /* Langer Titel am Laptop, kurzer am Handy (CSS blendet um): neben
       Bildern und Pille bleiben dort nur ~125px fuer den Text. */
    var tLang = document.createElement('span'); tLang.className = 'ax-bundle__t-lang'; tLang.textContent = T.titel;
    var tKurz = document.createElement('span'); tKurz.className = 'ax-bundle__t-kurz'; tKurz.textContent = T.kurz;
    txt.appendChild(tLang); txt.appendChild(tKurz);
    /* Die Zeile "Mit <Partnerprodukt>" wird berechnet, aber nicht mehr
       angezeigt (Marvin, 09.09.: "nimm das weg mit den Shorts") -- die
       Liste im offenen Fenster zeigt die Produkte ohnehin. */
    sub = document.createElement('small');
    sub.textContent = T.sub;
    sub.hidden = true;
    preisEl = document.createElement('span');
    preisEl.className = 'ax-bundle__preis';
    preisEl.hidden = true;
    txt.appendChild(preisEl);
    head.addEventListener('click', function () {
      if (body.hidden) oeffnen(false); else schliessen();
    });
    /* Aenderungen im Fenster (Zeilen laden nach, Preise wechseln) */
    new MutationObserver(function () { auffrischen(); }).observe(body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'src', 'srcset', 'data-src']
    });
    body.addEventListener('load', function (event) {
      if (event.target.tagName === 'IMG') auffrischen();
    }, true);
    return box;
  }

  /* Hinter den Vertrauenskasten (.ax-trust); fehlt er, hinter die
     Instagram-Zeile; fehlt auch die, hinter den Kaufknopf-Block.
     Reihenfolge seit 09.09. (Marvin: "bau das so, wie du denkst"):
     Knopf, Lieferzeile, Vertrauenskasten, Bundle, Instagram-Zeile,
     Akkordeons. Lieferzeile und Kasten gehoeren an den Moment des
     Klicks; das Angebot folgt gleich danach, noch vor der weicheren
     Folgen-Zeile -- zwischen zwei ruhigen Kaesten faellt der
     Navy-Rahmen auf. */
  function platzieren() {
    var trust = info.querySelector('.ax-trust');
    var ig = info.querySelector('.ax-ig-wrap');
    var ref = trust || ig;
    var anker = ref ? (ref.closest('.hdt-product-info__item') || ref) : buy;
    if (anker.nextElementSibling !== box) anker.insertAdjacentElement('afterend', box);
  }

  function uebernehmen() {
    var teile = info.querySelectorAll('.pmpr_bundle__root, .pmpr_bundle__inActive_state');
    for (var i = 0; i < teile.length; i++) {
      if (!body.contains(teile[i])) body.appendChild(teile[i]);
    }
  }

  function ausgeblendet(element) {
    for (var node = element; node && node !== body; node = node.parentElement) {
      if (node.hidden || node.classList.contains('pmpr_d-none') || node.getAttribute('aria-hidden') === 'true') return true;
      var stil = window.getComputedStyle(node);
      if (stil.display === 'none' || stil.visibility === 'hidden' || stil.visibility === 'collapse') return true;
    }
    return false;
  }

  function angebot() {
    var roots = body.querySelectorAll('.pmpr_bundle__root');
    for (var i = 0; i < roots.length; i++) {
      if (ausgeblendet(roots[i])) continue;
      var zeilen = Array.prototype.filter.call(roots[i].querySelectorAll('.pmpr_bundle__product'), function (zeile) {
        return zeile.closest('.pmpr_bundle__root') === roots[i] && !ausgeblendet(zeile);
      });
      if (zeilen.length > 1) return { root: roots[i], zeilen: zeilen };
    }
    return null;
  }

  function auffrischen() {
    bauen();
    platzieren();
    uebernehmen();
    var aktuell = angebot();
    var da = !!aktuell;
    if (box.hidden === da) box.hidden = !da;
    if (da) {
      /* Erklaerung: die Partner-Produkte des Bundles, ohne das Produkt
         der Seite selbst (das die App als erste Zeile mitfuehrt). */
      var eigener = document.querySelector('.hdt-product__title');
      eigener = eigener ? eigener.textContent.trim() : '';
      var partner = [];
      var zeilen = aktuell.zeilen;
      for (var k = 0; k < zeilen.length; k++) {
        /* Jede Zeile fuehrt zuerst einen leeren .pmpr_bundle__product_title
           (gemessen 09.09.), der Name steht in .pmpr_bundle__product_name_text
           oder im zweiten Titel-Element -- darum: erstes nicht-leeres. */
        var kandidaten = zeilen[k].querySelectorAll('.pmpr_bundle__product_name_text, .pmpr_bundle__product_title');
        var name = '';
        for (var m = 0; m < kandidaten.length && !name; m++) name = kandidaten[m].textContent.trim();
        if (name && name !== eigener && partner.indexOf(name) < 0) partner.push(name);
      }
      var text = partner.length ? T.mit + partner.join(' + ') + T.ende : T.sub;
      if (sub.textContent !== text) sub.textContent = text;

      /* Produktbilder: je Zeile das erste Bild, verkleinert. Nur neu
         bauen, wenn sich der Satz aendert. */
      var bilder = [];
      for (var b = 0; b < zeilen.length; b++) {
        var im = zeilen[b].querySelector('.pmpr_bundle__product_img img') || zeilen[b].querySelector('img');
        var src = im ? (im.currentSrc || im.getAttribute('src') || '') : '';
        if (src) bilder.push(src);
      }
      var schluessel = bilder.join('|');
      if (thumbs && thumbs.getAttribute('data-key') !== schluessel) {
        thumbs.setAttribute('data-key', schluessel);
        while (thumbs.firstChild) thumbs.removeChild(thumbs.firstChild);
        for (var c = 0; c < bilder.length; c++) {
          var sp = document.createElement('span');
          sp.className = 'ax-bundle__thumb';
          var img = document.createElement('img');
          img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          img.width = 40; img.height = 40;
          img.src = klein(bilder[c]);
          sp.appendChild(img);
          thumbs.appendChild(sp);
        }
        box.classList.toggle('has-thumbs', bilder.length > 0);
      }

      /* Bundle-Preis aus dem Fenster: "CHF 94.50 statt CHF 105.00". */
      var total = aktuell.root.querySelector('.pmpr_bundle__total_price_text');
      var vergleich = aktuell.root.querySelector('.pmpr_bundle__compare_price_text');
      var tp = total ? total.textContent.trim() : '';
      var vp = vergleich ? vergleich.textContent.trim() : '';
      var pk = tp + '|' + vp;
      if (preisEl && preisEl.getAttribute('data-key') !== pk) {
        preisEl.setAttribute('data-key', pk);
        while (preisEl.firstChild) preisEl.removeChild(preisEl.firstChild);
        if (tp) {
          var bb = document.createElement('b'); bb.textContent = tp; preisEl.appendChild(bb);
          if (vp && vp !== tp) {
            /* Waehrung nur einmal: "CHF 94.50 statt 105.00" */
            var praefix = (tp.match(/^[^\d]+/) || [''])[0];
            var vpKurz = (praefix && vp.indexOf(praefix) === 0) ? vp.slice(praefix.length) : vp;
            /* "statt" als eigenes Element: am Handy blendet CSS es aus,
               sonst bricht die Preiszeile in der schmalen Spalte um. */
            var st = document.createElement('span'); st.className = 'ax-bundle__statt';
            st.textContent = en ? ' instead of ' : ' statt ';
            preisEl.appendChild(st);
            var ss = document.createElement('s'); ss.textContent = vpKurz; preisEl.appendChild(ss);
          }
        }
        preisEl.hidden = !tp;
      }
    }
    var hints = document.querySelectorAll('.ax-bh');
    for (var j = 0; j < hints.length; j++) hints[j].classList.toggle('ax-bh--da', da);
  }

  function kopfhoehe() {
    var h = document.querySelector('.hdt-sticky-header') || document.querySelector('header');
    return (h ? h.getBoundingClientRect().height : 0) + 20;
  }

  /* Weiches Auf- und Zuklappen (Marvin, 09.09.: "nicht smoothe Animation
     wenn geoeffnet wird"): die Hoehe laeuft von 0 auf die Inhaltshoehe
     mit der Hauskurve, dazu ein kurzes Einblenden. Danach wird die
     Hoehe wieder freigegeben, damit das Fenster mit dem Inhalt waechst.
     Bei reduzierter Bewegung schaltet es hart um. */
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KURVE = 'cubic-bezier(.16, 1, .3, 1)';
  var laufend = null;

  function aufraeumen() {
    body.style.height = ''; body.style.overflow = ''; body.style.transition = ''; body.style.opacity = '';
    if (laufend) { body.removeEventListener('transitionend', laufend.ende); clearTimeout(laufend.uhr); laufend = null; }
  }

  function oeffnen(scrollen) {
    bauen();
    aufraeumen();
    body.hidden = false;
    head.setAttribute('aria-expanded', 'true');
    box.classList.add('is-open');
    if (cta) cta.textContent = T.zu;
    if (!ruhig) {
      body.style.overflow = 'hidden';
      body.style.height = '0px';
      body.style.opacity = '0';
      void body.offsetHeight;
      var ziel = body.scrollHeight;
      body.style.transition = 'height .36s ' + KURVE + ', opacity .28s ease';
      body.style.height = ziel + 'px';
      body.style.opacity = '1';
      var ende = function (e) { if (e && e.target !== body) return; aufraeumen(); };
      laufend = { ende: ende, uhr: setTimeout(ende, 450) };
      body.addEventListener('transitionend', ende);
    }
    if (scrollen) {
      var y = box.getBoundingClientRect().top + window.pageYOffset - kopfhoehe();
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  function schliessen() {
    aufraeumen();
    head.setAttribute('aria-expanded', 'false');
    box.classList.remove('is-open');
    if (cta) cta.textContent = T.auf;
    if (ruhig || body.hidden) { body.hidden = true; return; }
    body.style.overflow = 'hidden';
    body.style.height = body.scrollHeight + 'px';
    body.style.opacity = '1';
    void body.offsetHeight;
    body.style.transition = 'height .3s ' + KURVE + ', opacity .22s ease';
    body.style.height = '0px';
    body.style.opacity = '0';
    var ende = function (e) { if (e && e.target !== body) return; body.hidden = true; aufraeumen(); };
    laufend = { ende: ende, uhr: setTimeout(ende, 400) };
    body.addEventListener('transitionend', ende);
  }

  window.axBundle = { open: oeffnen, close: schliessen, refresh: auffrischen };

  /* Preis-Hinweis ohne eigenes Skript (nach Variantenwechsel): Klick
     oeffnet und scrollt. Mit eigenem Skript (data-ax-bound) macht der
     Block das selbst. */
  document.addEventListener('click', function (e) {
    var h = e.target && e.target.closest ? e.target.closest('.ax-bh') : null;
    if (!h || h.dataset.axBound) return;
    oeffnen(true);
  });

  new MutationObserver(function () { auffrischen(); }).observe(buy, { childList: true });
  document.addEventListener('variant-change', function () { setTimeout(auffrischen, 60); });

  /* Die App laedt nach und fuellt ihre Zeilen asynchron: eine halbe
     Minute lang nachsehen, danach reicht der Beobachter. */
  var laeufe = 0;
  var uhr = setInterval(function () {
    auffrischen();
    if (++laeufe > 60) clearInterval(uhr);
  }, 500);
  auffrischen();
})();
